export default __webpack_public_path__ + "static/media/meeting.4e31a85b.svg";